import { CtaWithCustomAuthor } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './AuthorQuote.module.scss';
import Blockquote from '../../page-components/Blog/Article/Blockquote';

const AuthorQuote = ({ data }: { data: CtaWithCustomAuthor }) => (
  <section className={classNames(styles.authorQuoteSection, 'container')}>
    <Blockquote
      text={data.quote}
      authorName={data.name}
      authorPosition={data.position}
      authorImage={data?.avatar?.url}
    />
  </section>
);

export default AuthorQuote;
